var chunkToChildrenMap = {
	"3727": [
		461,
		6807,
		8281,
		7241,
		9883,
		539,
		934,
		7704,
		4058,
		2455,
		1252,
		3587,
		5992,
		7832,
		8444,
		6081,
		2143,
		3438,
		2300,
		6994,
		9379,
		8505,
		9518,
		2239
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));